module.exports = __webpack_public_path__ + "img/comparison_additional-hospitality.4fb13e1e.jpg";